'use client'

import React, { useState, useEffect } from 'react'
import { ArrowUpOutlined } from '@ant-design/icons'
import { usePathname } from 'next/navigation'
export default function ScrollToTop() {
  // 特定页面隐藏footer
  const pathName = usePathname()
  const notShowFooterList = ['rent-to-own/unsubscribe-or-buy', 'my-cart']
  useEffect(() => {
    const shouldHideFooter = notShowFooterList.some((item) => pathName.includes(item)) || (pathName.includes('rent-to-own/add') && !pathName.includes('rent-to-own/add-to-pay'))
    if (shouldHideFooter) {
      document.querySelector('footer')?.classList.add('hidden')
    } else {
      document.querySelector('footer')?.classList.remove('hidden')
    }
  }, [pathName])

  return (
    <div
      onClick={() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }}
      className="fixed bottom-[14px] right-[16px] z-[2000] block h-[44px] w-[44px] cursor-pointer rounded-[50%] bg-[rgba(0,0,0,0.3)] text-center text-[18px] leading-[44px] text-white no-underline">
      <ArrowUpOutlined />
    </div>
  )
}
